import React from "react";
import FeaturePanel from "./FeaturePanel";
import img from "../../../../assets/images/img-home.jpg";
import e9 from "../../../../assets/images/home_panels/e9.jpg";
import gm from "../../../../assets/images/home_panels/green-machine.PNG";
import sweat from "../../../../assets/images/home_panels/sweat-tool.PNG";
import slack from "../../../../assets/images/home_panels/slack.jpg";

export default function FeaturePanels() {
  const panels = [
    {
      image: slack,
      alt: "Test",
      title: "Join thousands of other DFS players in the Gup's Corner Slack",
      content:
        "Bounce ideas around, get live plays from Gup, and sweat with the community.",
      byline: "Community",
    },
    {
      image: gm,
      alt: "Test",
      title: "Quickly generate lineups built to win you $$$",
      content:
        "Build like a shark, creating up to 150 lineups fine tuned to your specifications.",
      byline: "Green Machine",
    },
    {
      image: sweat,
      alt: "Test",
      title: "Sweat your lineups right down to the wire",
      content:
        "From the first tee, to the nail biter cut, to the dramatic finish: track your lineups like never before. ",
      byline: "PGA Live Contest Tracker",
    },
    {
      image: e9,
      alt: "Test",
      title: "Get access to in depth analysis from Gup and The Team",
      content: "Member only pods to give you a leg up on the competition.",
      byline: "Podcasts",
    },
  ];

  return (
    <div className="feature-panels">
      {panels.map((panel, index) => {
        return (
          <FeaturePanel
            key={index}
            rank={index}
            image={panel.image}
            alt={panel.alt}
            title={panel.title}
            content={panel.content}
            byline={panel.byline}
            imageLeft={index % 2 === 0}
          />
        );
      })}
    </div>
  );
}
